export default "__VITE_ASSET__3d0a176f__$_?nuxt_component=async__"